import { DeckPrint, DeckViewer, Frame, Img } from "../headliner/DeckShell";
import { TEAM } from "../headliner/TeamAndPartners";
import { KOMITE as FORANKRING } from "../investordeck/InvestorSlides";
import "../headliner/headliner.css";
import "../buildpartner/build.css";
import "./team.css";

/* «Hvem står bak» — norsk énsider til sponsorer og samarbeidspartnere. Ikke Bergen-spesifikk.
   Åpen lenke uten passord (kun bekreftede fakta) · kategorifelt «dialog» (admin) viser statuser, programkomité og frontier-lab-sporet.
   Replit-status: har sagt ja i prinsippet til Official Build Partner (LinkedIn, Brendan Dugan), avtale formaliseres okt. 2026 — ikke «avtalt».
   Anthropic: kun i dialogvarianten — Replit har tilbudt en introduksjon, ingen samtaler gjennomført. Tall om Replit: Replits egne (11. mars 2026). */
const dialogOf = (c) => (c || "").toLowerCase().split(/\s+/).includes("dialog");

const ROLLE = {
  "Martin Kviteberg": ["Daglig leder", "Program, partnere og gjennomføring"],
  "Sarah Sleeman": ["Partner", "Drift og opplevelse"],
  "Sigrid Kviteberg": ["Partner", "Teknologi · Global InTech AS"],
  "Vernand Morency": ["Internasjonale relasjoner og partnerskap", "Tidligere NFL — Green Bay Packers, Houston Texans. Eiendomsutvikler, Washington DC."],
};
const REPLIT = [
  ["50+ mill.", "brukere"],
  ["9 mrd. USD", "verdsettelse etter Serie D, mars 2026"],
  ["85 %", "av Fortune 500 har ansatte som bygger på Replit"],
  ["1 mrd. USD", "løpende omsetning, ventet ved utgangen av 2026"],
];
const LEVERES = [
  ["Grieghallen", "/logos/grieghallen.svg", "grieghallen", "Arena · Peer Gynt-salen", "Tilbud mottatt", "on"],
  ["Unite Event", "/logos/unite.svg", "unite", "Produksjon og gjennomføring · har produsert i Peer Gynt-salen", "Foreslått", ""],
  ["Cure", "/logos/cure.svg", "cure", "Merkevare, medier og distribusjon", "Foreslått", ""],
];
const KORT = (n) => (n.startsWith("VIS") ? "VIS" : n);
const KOMITE = [[KORT(FORANKRING[0][0]), FORANKRING[0][2]], ["Replit", "Ja i prinsippet"], ...FORANKRING.slice(1).map(([n, , st]) => [KORT(n), st])];
const stOn = (st) => /^(Ja|Interesse|Bekreftet)/.test(st);
export const TEAM_ONEPAGER_ASSETS = [...TEAM.map((t) => t[2]), ...LEVERES.map((d) => d[1]), "/logos/partners/replit.svg"];

const HvemStarBak = ({ nr, category }) => {
  const dialog = dialogOf(category);
  return (
    <Frame nr={nr} label="Hvem står bak" prep="" className="tm hd-light">
      <h2 className="hd-h2" data-testid="tm-h">Hvem står bak Norwegian AI Summit.</h2>
      <p className="tm-sub" data-testid="tm-sub">700 ledere fra hele landet samles i Grieghallen 13. april 2027. Bak arrangementet står et lite team med internasjonal erfaring, et av verdens raskest voksende AI-selskaper som Build Partner, og etablerte norske leveransepartnere.</p>

      <div className="tm-col tm-team" data-testid="tm-team">
        <span className="k">Teamet</span>
        <ul>{TEAM.map(([n, , img]) => <li key={n} data-testid={`tm-team-${n.split(" ")[0].toLowerCase()}`}><Img src={img} alt={n} className="ph" draggable={false} /><span><b>{n}</b><i>{ROLLE[n][0]}</i><em>{ROLLE[n][1]}</em></span></li>)}</ul>
      </div>

      <div className="tm-col tm-replit" data-testid="tm-replit">
        <span className="k" data-testid="tm-replit-k">Build Partner{dialog && <> · <span className="st on">Ja i prinsippet</span> · avtale formaliseres oktober 2026</>}</span>
        <i className="mask replit" style={{ "--m": "url(/logos/partners/replit.svg)" }} aria-label="Replit" />
        <dl className="tm-facts" data-testid="tm-replit-facts">{REPLIT.map(([v, l]) => <div key={l}><dt>{v}</dt><dd>{l}</dd></div>)}</dl>
        <p className="d" data-testid="tm-replit-d">Replit lar hvem som helst bygge programvare ved å beskrive den. På Norwegian AI Summit tar Replit en reell forretningsutfordring og bygger en fungerende løsning live på hovedscenen — fra problem til produkt, foran 700 ledere. Build Lab holder åpent hele dagen.</p>
        <p className="src" data-testid="tm-replit-src">Replit har sagt ja til rollen som Official Build Partner. Tall: Replit, 11. mars 2026 — Serie D på 400 MUSD ledet av Georgian, med a16z, Coatue og Y Combinator blant investorene.</p>
        {dialog && (
          <>
            <span className="k k2">Frontier-lab · <span className="st">Intro under arbeid</span></span>
            <p className="tm-lab" data-testid="tm-frontier">Målet er å få ett av frontier-laboratoriene (OpenAI, Anthropic, Google DeepMind) inn i programmet. Replit har tilbudt en introduksjon til Anthropic. Samtaler er ikke startet.</p>
          </>
        )}
      </div>

      <div className="tm-col tm-lev" data-testid="tm-lev">
        <span className="k">Leveres med</span>
        <ul>{LEVERES.map(([n, logo, cls, r, st, on]) => <li key={n} data-testid={`tm-lev-${cls}`}><i className={`mask ${cls}`} style={{ "--m": `url(${logo})` }} aria-label={n} /><span className="r">{r}</span>{dialog && <span className={`st ${on}`}>{st}</span>}</li>)}</ul>
        <span className="k k2">Hovedtaler</span>
        <p className="tm-kevin" data-testid="tm-kevin"><b>Kevin O'Leary</b><i>Foreslått åpningstaler · tilgjengelighet bekreftet for 13. april 2027{dialog ? " · ikke kontrahert" : ""}</i></p>
        {dialog && (
          <>
            <span className="k k2">Programkomité · under etablering</span>
            <ul className="tm-kom" data-testid="tm-kom">{KOMITE.map(([n, st]) => <li key={n}><b>{n}</b><span className={`st ${stOn(st) ? "on" : ""}`}>{st}</span></li>)}</ul>
          </>
        )}
      </div>

      <p className="bd-foot tm-foot" data-testid="tm-foot">
        {dialog
          ? <><b>Ja i prinsippet</b> — sagt ja, avtale formaliseres · <b>Tilbud mottatt</b> — skriftlig, ikke signert · <b>Interesse bekreftet</b> — sagt ja til å gå videre · <b>Vist interesse</b> — positiv første kontakt · <b>Foreslått / I dialog</b> — ingenting avtalt · <b>Intro under arbeid</b> — introduksjon tilbudt, ingen samtaler</>
          : <>Build Partner: Replit har sagt ja, avtalen formaliseres oktober 2026. Leveransepartnere: avtaler under etablering. Hovedtaler: tilgjengelighet bekreftet, kontrakt ikke signert. <b>norwegianaisummit.no</b></>}
      </p>
    </Frame>
  );
};

/* 02 Nettverket rundt — kun det som er sant. Status per organisasjon hentes fra samme kilde som «Hvem står bak» (KOMITE). Ingen roller påstås. */
const NETT = [
  ["Bergen Næringsråd", "Næringsliv", "Næringslivets medlemsorganisasjon i Bergensregionen", "naeringsrad", "/logos/bergen-naeringsrad.svg"],
  ["Medieklyngen", "Klynge", "Media City Bergen — medier, teknologi og akademia", "medieklyngen", "/logos/medieklyngen.svg"],
  ["VIS — Vestlandets innovasjonsselskap", "Innovasjon", "Forskning, inkubasjon og oppstartsselskaper", "vis", "/logos/vis.png"],
  ["Handelshøyskolen BI", "Akademia", "Handelshøyskole med campus i Bergen", "bi", "/logos/bi.svg"],
];
const STATUS = Object.fromEntries(FORANKRING.map(([n, , st, on]) => [n, [st, on]]));
export const NETT_ASSETS = NETT.map((n) => n[4]);
const GIR = [
  ["Programkomité", "Programmet kvalitetssikres av folk som kjenner norsk næringsliv — ikke bare av oss."],
  ["Rekkevidde", "Invitasjonene går gjennom nettverk der lederne allerede er medlemmer."],
  ["Faglig tyngde", "Akademia i programmet gir substans utover leverandørenes budskap."],
];
export const Nettverket = ({ nr, mottaker, prep = "", label = "Hvem står bak" }) => (
  <Frame nr={nr} label={label} prep={prep} mottaker={mottaker} className="tm tm2 hd-light">
    <h2 className="hd-h2" data-testid="tm2-h">Nettverket rundt.</h2>
    <p className="tm-sub" data-testid="tm2-sub">Et nasjonalt ledermøte må være forankret der beslutningstakerne allerede møtes: i næringslivets organisasjoner, i klyngene og i akademia. Vi begynner i Bergen, der konferansen holdes. Organisasjonene under har vist interesse, og vi er i dialog med hver av dem. Ingenting er avtalt; hva et samarbeid skal bestå i, avklares én og én.</p>

    <div className="tm-col tm2-why" data-testid="tm2-why">
      <span className="k">Hva forankringen skal gi</span>
      <ol>{GIR.map(([t, d], i) => <li key={t}><span className="n">{String(i + 1).padStart(2, "0")}</span><span><b>{t}</b><em>{d}</em></span></li>)}</ol>
    </div>

    <div className="tm-col tm2-list" data-testid="tm2-list">
      <span className="k">Status per organisasjon</span>
      <ul>{NETT.map(([n, kat, d, id, logo]) => <li key={n} data-testid={`tm2-${id}`}><i className={`mask lg ${id}`} style={{ "--m": `url(${logo})` }} aria-label={n} /><span><span className="kat">{kat}</span><b>{n}</b><em>{d}</em></span><span className={`st ${STATUS[n]?.[1] || ""}`}>{STATUS[n]?.[0] || "I dialog"}</span></li>)}</ul>
    </div>

    <p className="bd-foot tm-foot" data-testid="tm2-foot"><b>Interesse bekreftet</b> — har sagt ja til å gå videre · <b>Vist interesse</b> — positiv første kontakt · <b>I dialog</b> — samtaler pågår; ingenting er avtalt · Programkomiteen er under etablering (se «Hvem står bak»).</p>
  </Frame>
);


const slidesFor = (_m, category) => (dialogOf(category) ? [HvemStarBak, Nettverket] : [HvemStarBak]);


export function TeamPrint() {
  return <DeckPrint slides={slidesFor} fallback="" theme="light" />;
}

export default function TeamDeck({ publicMode = false }) {
  return <DeckViewer deck="team" slides={slidesFor} fallback="" filePrefix="Norwegian-AI-Summit-Hvem-star-bak" assets={[...TEAM_ONEPAGER_ASSETS, ...NETT_ASSETS]} publicMode={publicMode} categoryField="variant" no />;
}
